import React, {useEffect} from "react";
import {useLocation, useHistory} from 'react-router-dom';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon,
    IonFooter
} from '@ionic/react';
import {closeOutline} from 'ionicons/icons';
import CommonHeader from "../../Components/CommonHeader";


const WrapperIonModal = (
    {
        isOpen = false,
        toggle,
        title = '',
        headerComponent,
        footer = '',
        children,
    }
) => {

    const onDismiss = ()=>{
        toggle(false);
    }

    return <IonModal isOpen={!!isOpen} onDidDismiss={onDismiss}>
                <CommonHeader  title={title} onBackButtonClick={onDismiss} component={headerComponent}/>
                <IonContent forceOverscroll={false}>
                    {children}
                </IonContent>
                {footer ?
                    <IonFooter>
                        <IonToolbar>
                            {footer}
                        </IonToolbar>
                    </IonFooter>
                 : null}
            </IonModal>
};


export default WrapperIonModal;
